import * as actionType from "./constants";

const initialState = {
    getRecommendationAcceptableVerbDataResponse: null,
    addRecommendationAcceptableVerbResponse: null,
    getRecommendationAcceptableVerbByIdResponse: null,
    updateRecommendationAcceptableVerbResponse: null,
    deleteRecommendationAcceptableVerbResponse: null,
    getListForRecommendationAcceptableVerbResponse: null,
    getAllRecommendationAcceptableVerbLogsResponse: null,
    restoreRecommendationAcceptableVerbLogResponse: null,
    deleteRecommendationAcceptableVerbLogResponse: null,
    recommendationAcceptableVerbExportResponse: null,
    entityParams: {
        entity: null,
        selectedEntity: null,
        selectedRowId: null,
        paginationParams: {
            totalPages: 0,
            perPage: 100,
            currentPage: 0,
            totalCount: 0
        },
        params: {
            limit: 100,
            offset: 0,
            search: "",
            filters: null,
            list: null
        },
        wildCardFilterParams: {},
        filterParams: {},
        tableConfig: null,
        historyPaginationParams: {
            totalPages: 0,
            perPage: 40,
            currentPage: 0,
            totalCount: 0
        },
        historyParams: {
            limit: 40,
            offset: 0,
            search: ""
        }
    }
};

export default (state = initialState, action) => {
    switch (action.type) {
        case actionType.UPDATE_RECOMMENDATION_ACCEPTABLE_VERB_ENTITY_PARAMS_SUCCESS:
            return {
                ...state,
                entityParams: { ...action.response }
            };
        case actionType.UPDATE_RECOMMENDATION_ACCEPTABLE_VERB_ENTITY_PARAMS_FAILURE:
            return {
                ...state,
                entityParams: { ...action.error }
            };
        case actionType.GET_LIST_FOR_RECOMMENDATION_ACCEPTABLE_VERB_FILTER_REQUEST:
            return {
                ...state
            };
        case actionType.GET_LIST_FOR_RECOMMENDATION_ACCEPTABLE_VERB_FILTER_SUCCESS:
            return {
                ...state,
                getListForRecommendationAcceptableVerbResponse: { success: true, ...action.response }
            };
        case actionType.GET_LIST_FOR_RECOMMENDATION_ACCEPTABLE_VERB_FILTER_FAILURE:
            return {
                ...state,
                getListForRECOMMENDATION_ACCEPTABLE_VERBFilterResponse: { success: false, ...action.error }
            };
        case actionType.GET_RECOMMENDATION_ACCEPTABLE_VERB_DATA_REQUEST:
            return {
                ...state
            };
        case actionType.GET_RECOMMENDATION_ACCEPTABLE_VERB_DATA_SUCCESS:
            return {
                ...state,
                getRecommendationAcceptableVerbDataResponse: { success: true, ...action.response }
            };
        case actionType.GET_RECOMMENDATION_ACCEPTABLE_VERB_DATA_FAILURE:
            return {
                ...state,
                getRecommendationAcceptableVerbDataResponse: { success: false, ...action.error }
            };
        case actionType.ADD_RECOMMENDATION_ACCEPTABLE_VERB_REQUEST:
            return {
                ...state
            };
        case actionType.ADD_RECOMMENDATION_ACCEPTABLE_VERB_SUCCESS:
            return {
                ...state,
                addRecommendationAcceptableVerbResponse: { success: true, ...action.response }
            };
        case actionType.ADD_RECOMMENDATION_ACCEPTABLE_VERB_FAILURE:
            return {
                ...state,
                addRecommendationAcceptableVerbResponse: { success: false, ...action.error }
            };
        case actionType.GET_RECOMMENDATION_ACCEPTABLE_VERB_BY_ID_REQUEST:
            return {
                ...state
            };
        case actionType.GET_RECOMMENDATION_ACCEPTABLE_VERB_BY_ID_SUCCESS:
            return {
                ...state,
                getRecommendationAcceptableVerbByIdResponse: { success: true, ...action.response }
            };
        case actionType.GET_RECOMMENDATION_ACCEPTABLE_VERB_BY_ID_FAILURE:
            return {
                ...state,
                getRecommendationAcceptableVerbByIdResponse: { success: false, ...action.error }
            };
        case actionType.UPDATE_RECOMMENDATION_ACCEPTABLE_VERB_REQUEST:
            return {
                ...state
            };
        case actionType.UPDATE_RECOMMENDATION_ACCEPTABLE_VERB_SUCCESS:
            return {
                ...state,
                updateRecommendationAcceptableVerbResponse: { success: true, ...action.response }
            };
        case actionType.UPDATE_RECOMMENDATION_ACCEPTABLE_VERB_FAILURE:
            return {
                ...state,
                updateRecommendationAcceptableVerbResponse: { success: false, ...action.error }
            };
        case actionType.DELETE_RECOMMENDATION_ACCEPTABLE_VERB_REQUEST:
            return {
                ...state
            };
        case actionType.DELETE_RECOMMENDATION_ACCEPTABLE_VERB_SUCCESS:
            return {
                ...state,
                deleteRecommendationAcceptableVerbResponse: { success: true, ...action.response }
            };
        case actionType.DELETE_RECOMMENDATION_ACCEPTABLE_VERB_FAILURE:
            return {
                ...state,
                deleteRecommendationAcceptableVerbResponse: { success: false, ...action.error }
            };
        case actionType.GET_ALL_RECOMMENDATION_ACCEPTABLE_VERB_LOG_REQUEST:
            return {
                ...state
            };
        case actionType.GET_ALL_RECOMMENDATION_ACCEPTABLE_VERB_LOG_SUCCESS:
            return {
                ...state,
                getAllRecommendationAcceptableVerbLogsResponse: { success: true, ...action.response }
            };
        case actionType.GET_ALL_RECOMMENDATION_ACCEPTABLE_VERB_LOG_FAILURE:
            return {
                ...state,
                getAllRecommendationAcceptableVerbLogsResponse: { success: false, ...action.error }
            };
        case actionType.RESTORE_RECOMMENDATION_ACCEPTABLE_VERB_LOG_REQUEST:
            return {
                ...state
            };
        case actionType.RESTORE_RECOMMENDATION_ACCEPTABLE_VERB_LOG_SUCCESS:
            return {
                ...state,
                restoreRecommendationAcceptableVerbLogResponse: { success: true, ...action.response }
            };
        case actionType.RESTORE_RECOMMENDATION_ACCEPTABLE_VERB_LOG_FAILURE:
            return {
                ...state,
                restoreRecommendationAcceptableVerbLogResponse: { success: false, ...action.error }
            };

        case actionType.DELETE_RECOMMENDATION_ACCEPTABLE_VERB_LOG_REQUEST:
            return {
                ...state
            };
        case actionType.DELETE_RECOMMENDATION_ACCEPTABLE_VERB_LOG_SUCCESS:
            return {
                ...state,
                deleteRecommendationAcceptableVerbLogResponse: { success: true, ...action.response }
            };
        case actionType.DELETE_RECOMMENDATION_ACCEPTABLE_VERB_LOG_FAILURE:
            return {
                ...state,
                deleteRecommendationAcceptableVerbLogResponse: { success: false, ...action.error }
            };
        case actionType.GET_RECOMMENDATION_ACCEPTABLE_VERB_EXPORT_REQUEST:
            return {
                ...state
            };
        case actionType.GET_RECOMMENDATION_ACCEPTABLE_VERB_EXPORT_SUCCESS:
            return {
                ...state,
                recommendationAcceptableVerbExportResponse: { success: true, ...action.response }
            };
        case actionType.GET_RECOMMENDATION_ACCEPTABLE_VERB_EXPORT_FAILURE:
            return {
                ...state,
                recommendationAcceptableVerbExportResponse: { success: false, ...action.error }
            };
        case actionType.RESET_REDUCER:
            return {
                ...state,
                ...(action?.entity === "reset_all" ? { getRecommendationAcceptableVerbDataResponse: null } : {}),
                restoreRecommendationAcceptableVerbLogResponse: null,
                deleteRecommendationAcceptableVerbLogResponse: null,
                updateRecommendationAcceptableVerbResponse: null,
                deleteRecommendationAcceptableVerbResponse: null,
                addRecommendationAcceptableVerbResponse: null
            };
        default:
            return state;
    }
};
